// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","developer-link":"Footer_developer-link__X5Dwx"};